import { render, staticRenderFns } from "./channel-tag.vue?vue&type=template&id=4537711d&scoped=true&"
import script from "./channel-tag.vue?vue&type=script&lang=js&"
export * from "./channel-tag.vue?vue&type=script&lang=js&"
import style0 from "./channel-tag.vue?vue&type=style&index=0&id=4537711d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537711d",
  null
  
)

export default component.exports